import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LocaleContext } from 'routes/Router';
import requestCheck from 'assets/images/Dashboard/chevron-right-request.svg';
import ArrowDetail from 'assets/images/Dashboard/arrow-left-request-detail.svg';
import LabelWithInput from 'components/commom/LabelWithPracticeInput';
import SelectInput from 'components/commom/SelectInput';
import ReusableButton from 'components/commom/Button';
import AddOption from 'assets/images/Dashboard/add-dashboard-black.svg';
import { getCategoryListData } from 'store/categoryList/categoryListAction';
import { ClearTokenRedirectLogin } from 'utils/general';
import { getMasterData } from 'store/masterData/masterDataAction';
import SwitchList from 'components/commom/SwitchList';
import { postQuestionRequest } from 'store/createQuestion/createQuestionAction';
import CheckValidation from 'utils/validate';
import { getQuestionDetailData } from 'store/questionDetail/questionDetailAction';
import { updateQuestion } from 'store/updateQuestion/updateQuestionAction';
import { questionnaire } from 'routes/AppUrls';
import CommonToast from 'components/commom/CommonToast';

const QuestionnaireDetail = () => {
  const intl = useIntl();
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const [isError, setIsError] = useState(false);
  const [formValue, setformValue] = useState({
    question_text: '',
    questionType: '',
    question_type_id: '',
    category: '',
    questionnaire_id: '',
    switchValue: false,
  });
  const [answers, setAnswers] = useState([{ answer_text: '' }]);
  const [errors, setErrors] = useState([]);

  const categoryListData = useSelector(
    (state) => state?.getCategoryListDataReducer?.users?.data
  );

  const questionType = useSelector(
    (state) => state?.getMasterDataReducer?.users?.data
  );

  const questionnaireId = useSelector(
    (state) => state?.basicDetailsValueReducer?.questionnaireId
  );

  const createReducer = useSelector(
    (state) => state?.postQuestionReducer?.loading
  );

  const updateReducer = useSelector(
    (state) => state?.updateQuestionReducer?.loading
  );

  useEffect(() => {
    typeSelectData();
    categoryData();
    if (questionnaireId) {
      questionDetail();
    }
  }, []);

  const typeSelectData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {},
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getMasterData(external, 'question-type'));
  };

  const categoryData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {},
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getCategoryListData(external));
  };

  const questionDetail = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        handleSuccess(res);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getQuestionDetailData(external, questionnaireId));
  };

  const handleSuccess = (res) => {
    setformValue((prev) => ({
      ...prev,
      question_text: res?.data?.question_text,
      questionType: res?.data?.question_type,
      category: res?.data?.category,
      switchValue: res?.data?.required,
      question_type_id: questionType?.[0]?.values?.find(
        (item) => item?.name === res?.data?.question_type
      )?.id,
      questionnaire_id: categoryListData?.find(
        (item) => item?.title === res?.data?.category
      )?.id,
    }));
    if (res?.data?.answers?.length > 0) {
      setAnswers(res.data.answers.map((answer) => ({ ...answer })));
    }
  };

  const handleInputChange = (event) => {
    const value = event?.target?.value;
    setformValue((prev) => ({
      ...prev,
      question_text: value,
    }));
  };

  const handleChange = (e) => {
    // const value = event?.target?.value;
    // setformValue((prev) => ({
    //   ...prev,
    //   questionType: value?.name,
    //   question_type_id: value?.id,
    //   category: value?.title,
    //   questionnaire_id: value?.id,
    // }));
    const { name, value } = e?.target;
    if (name === 'questionType') {
      setformValue((prev) => ({
        ...prev,
        questionType: value?.name,
        question_type_id: value?.id,
      }));
    }

    if (name === 'category') {
      setformValue((prev) => ({
        ...prev,
        category: value?.title,
        questionnaire_id: value?.id,
      }));
    }
  };

  const handleInputOptionChange = (index, event) => {
    const newAnswers = [...answers];
    newAnswers[index].answer_text = event.target.value;
    setAnswers(newAnswers);

    const newErrors = [...errors];
    newErrors[index] =
      event.target.value.trim() === '' ? 'field is required!' : '';
    setErrors(newErrors);
  };

  const handleAddOption = () => {
    setAnswers([...answers, { answer_text: '' }]);
  };

  const validateAnswers = () => {
    let newErrors = answers.map((answer) =>
      answer.answer_text.trim() === '' ? 'field is required!' : ''
    );

    setErrors(newErrors);
    return newErrors.every((error) => error === '');
  };

  const handleSwitchChange = (event) => {
    setformValue((prevState) => ({
      ...prevState,
      switchValue: event.target.checked,
    }));
  };

  const handleQuestion = () => {
    if (questionnaireId) {
      const external = {
        run: true,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
          navigate(questionnaire(locale));
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          if (
            formValue?.questionnaire_id !== '' &&
            formValue?.question_type_id !== '' &&
            formValue?.question_text !== '' &&
            answers &&
            answers?.length > 0
          ) {
            showToast(res?.message, 'error');
          }
          validateAnswers();
        },
      };
      const error = CheckValidation(formValue);
      setIsError(error);
      if (error.submit) {
        const body = {
          questionnaire_id: formValue?.questionnaire_id,
          question_type_id: formValue?.question_type_id,
          question_text: formValue?.question_text,
          answers: answers,
          required: formValue?.switchValue,
        };
        dispatch(updateQuestion(external, body, questionnaireId));
      }
    } else {
      const external = {
        run: true,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
          navigate(questionnaire(locale));
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          if (
            formValue?.questionnaire_id !== '' &&
            formValue?.question_type_id !== '' &&
            formValue?.question_text !== '' &&
            answers &&
            answers?.length > 0
          ) {
            showToast(res?.message, 'error');
          }
          validateAnswers();
        },
      };
      const error = CheckValidation(formValue);
      setIsError(error);
      if (error.submit) {
        let body = {
          questionnaire_id: formValue?.questionnaire_id,
          question_type_id: formValue?.question_type_id,
          question_text: formValue?.question_text,
          answers: answers,
          required: formValue?.switchValue,
        };
        dispatch(postQuestionRequest(body, external));
      }
    }
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <div className="flex pb-16">
            <div className="fs-12 lh-24 family_outfit_regular_400">
              Questionnaire
            </div>
            <div className="pl-04 flex items-center">
              <Image src={requestCheck} alt="icon" />
            </div>
            <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
              Add New Question
            </div>
          </div>
          <Row className="bg-light-100 m-0 p-24">
            <Col sm={12} className="p-0">
              <div className="flex">
                <div>
                  <Image
                    src={ArrowDetail}
                    alt="icon"
                    onClick={() => navigate(-1)}
                    className="cursor-pointer"
                  />
                </div>
                <div className="fs-20 lh-252 family_outfit_semiBold_600 fc-292D32 pl-12">
                  Add New Question
                </div>
              </div>
            </Col>
            <Col md={12} className="p-0">
              <div className="pt-24">
                <LabelWithInput
                  label="Question"
                  placeholder="Question"
                  name="question"
                  type="text"
                  value={formValue?.question_text}
                  onChange={(e) => handleInputChange(e)}
                  errorText={
                    isError &&
                    isError?.question_text?.error &&
                    isError?.question_text?.errorMessage
                  }
                />
              </div>
            </Col>
            <Col md={6} className="p-0">
              <div className="pt-24">
                <SelectInput
                  label="Type"
                  placeholder={intl.formatMessage({
                    id: 'Type',
                  })}
                  colorIcon={'#292D32'}
                  name={'questionType'}
                  value={formValue?.questionType}
                  data={questionType?.[0]?.values}
                  onChange={handleChange}
                  errorText={
                    isError &&
                    isError?.questionType?.error &&
                    isError?.questionType?.errorMessage
                  }
                />
              </div>
            </Col>
            <Col md={6} className="size-padding-question">
              <div className="pt-24">
                <SelectInput
                  label="Category "
                  placeholder={intl.formatMessage({
                    id: ' Category',
                  })}
                  colorIcon={'#292D32'}
                  name={'category'}
                  value={formValue?.category}
                  data={categoryListData}
                  onChange={handleChange}
                  errorText={
                    isError &&
                    isError?.category?.error &&
                    isError?.category?.errorMessage
                  }
                />
              </div>
            </Col>
            <Col md={12} className="p-0">
              <div className="fs-16 lh-201 family_outfit_semiBold_600 fc-292D32 pt-32">
                Options
              </div>
            </Col>

            {answers &&
              answers.length > 0 &&
              answers.map((answer, index) => (
                <Col md={12} className="p-0" key={index}>
                  <div className={index === 0 ? 'pt-24' : 'mt-4'}>
                    <LabelWithInput
                      label={`Option ${index + 1}`}
                      placeholder="Enter option"
                      name={`option-${index}`}
                      type="text"
                      value={answer?.answer_text}
                      onChange={(e) => handleInputOptionChange(index, e)}
                    />
                    {errors[index] && (
                      <span className="fs-16 lh-16 fc-FF0408 family_outfit_regular_400">
                        {errors[index]}
                      </span>
                    )}
                  </div>
                </Col>
              ))}
            <Col md={12} className="p-0">
              <div className="mt-10">
                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#3C3C3C"
                  fontSize="16px"
                  fontWeight="500"
                  padding="14px 52px"
                  borderRadius="0px"
                  height="44px"
                  bgColor="transparent"
                  brColor="#3C3C3C"
                  fontFamily="outfit_medium"
                  startIcon={<Image src={AddOption} />}
                  onClick={() => handleAddOption()}
                >
                  Add Another
                </ReusableButton>
              </div>
            </Col>
            <Col md={12} className="p-0">
              <Stack
                direction="horizontal"
                gap={2}
                className="items-center pt-48"
              >
                <div className="fs-14 lh-176 family_outfit_medium_500  fc-292D32">
                  Mandatory Field
                </div>
                <SwitchList
                  checked={formValue?.switchValue}
                  onChange={(e) => handleSwitchChange(e)}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
              </Stack>
            </Col>
            <Col md={12} className="p-0 flex justify-end">
              <Stack
                direction="horizontal"
                gap={2}
                className="flex items-center pt-40"
              >
                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#864629"
                  fontSize="16px"
                  fontWeight="400"
                  padding="14px 55px"
                  height="44px"
                  bgColor="transparent"
                  brColor="#EFE3D7"
                  fontFamily="outfit_regular"
                  onClick={() => navigate(-1)}
                >
                  <FormattedMessage id="Cancel" />
                </ReusableButton>
                <ReusableButton
                  fullWidth={false}
                  variant="contained"
                  color="#F5F5F5"
                  fontSize="16px"
                  fontWeight="500"
                  padding="14px 49px"
                  height="44px"
                  bgColor="#864629"
                  brColor="#864629"
                  fontFamily="outfit_medium"
                  onClick={() => {
                    (!updateReducer || !createReducer) && handleQuestion();
                  }}
                  loading={updateReducer || createReducer}
                >
                  <FormattedMessage id="Create Question" />
                </ReusableButton>
              </Stack>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default QuestionnaireDetail;
